module.exports = __webpack_public_path__ + "img/LaJolla.37a0b851.jpg";